// A stretch of time nobody has accounted for.
//
// One row, and only the dates on it. The question — were you working, or not? —
// is asked in the sheet this opens, not here, so the list stays readable when a
// history has several gaps.

import { ChevronRight } from 'lucide-react'

import { formatMonthRange } from 'src/utils/date/formatMonthPeriod'

export interface GapRowProps {
  startMonth: number
  endMonth: number
  onResolve: () => void
}

export const GapRow = ({ startMonth, endMonth, onResolve }: GapRowProps) => (
  <button
    type="button"
    onClick={onResolve}
    className="flex w-full items-center justify-between gap-2.5 rounded-[11px] border border-dashed border-doubleNickel-warning-300 bg-doubleNickel-warning-50 p-[11px] text-left"
  >
    <span className="text-[12.5px] font-medium text-doubleNickel-warning-700">
      {formatMonthRange(startMonth, endMonth)}
    </span>
    <ChevronRight size={16} className="text-doubleNickel-warning-600" />
  </button>
)
